import FacetedFiltering from '../components/FacetedFiltering';

export default class TemplateSearch {
  constructor({ el }) {
    this.el = el;
    this.filtersEnabled = this.el.querySelector('[data-faceted-filter]');

    if (this.filtersEnabled) {
      this.facetedFilters = new FacetedFiltering(this.el);
    }
  }

  onSectionUnload() {
    this.facetedFilters.unload();
  }
}
